/* global Popper */
'use strict'
const tooltip = {
	el: {
		tooltips: document.querySelectorAll('.js-tooltip')
	},

	vars: {
		showEvents: ['mouseenter', 'focus', 'click'],
		hideEvents: ['mouseleave', 'blur']
	},

	fxShowTooltip (el) {
		$(el.nextElementSibling).fadeIn(100)
		el.nextElementSibling.setAttribute('data-show', '')
		this.fxRenderTooltip(el)
	},

	fxHideTooltip (el) {
		$(el.nextElementSibling).fadeOut(100)
		el.nextElementSibling.removeAttribute('data-show')
	},

	fxRenderTooltip (el) {
		const triggerTooltip = el,
			tooltip = el.nextElementSibling,
			isTriggerOnClick = el.dataset.triggerOnclick === 'true',
			btnClose = isTriggerOnClick && tooltip.querySelector('.tooltip-close')
			
		if(isTriggerOnClick && !btnClose) {
			const btnCloseTooltip = document.createElement('span')
			btnCloseTooltip.classList.add('tooltip-close')
			tooltip.append(btnCloseTooltip)

			btnCloseTooltip.addEventListener('click', () => this.fxHideTooltip(el))
		}

		const popperInstance = Popper.createPopper(triggerTooltip, tooltip, {
			placement: 'top',
			modifiers: [{
				name: 'offset',
				options: {
					offset: [0, 10]
				}
			}]
		})
	},

	events () {
		if(this.el.tooltips.length === 0) return
		for (const tooltip of this.el.tooltips) {
			const isTriggerOnClick = tooltip.dataset.triggerOnclick === 'true',
				popperContainer = tooltip.nextElementSibling
			
			//-initiate popper
			this.fxRenderTooltip(tooltip)

			//trigger on mouse events/focus
			if(!isTriggerOnClick) {
				//-show tooltip on mouseover
				this.vars.showEvents.forEach(event => {
					//check if is mobile, if true trigger popper on click
					if(event === 'click' && window.matchMedia('only screen and (max-width: 768px)').matches) {
						tooltip.addEventListener(event, e => this.fxShowTooltip(e.currentTarget))
					} else {
						tooltip.addEventListener(event, e => this.fxShowTooltip(e.currentTarget))
					}
				})
			//trigger on click
			} else {
				tooltip.addEventListener('click', e => {
					const nextEl = e.currentTarget.nextElementSibling
					if(!nextEl.hasAttribute('data-show')) {
						this.fxShowTooltip(e.currentTarget)
					} else {
						this.fxHideTooltip(e.currentTarget)
					}
				})
			}

			//-hide tooltip on mouseout
			this.vars.hideEvents.forEach(event => {
				if(isTriggerOnClick) {
					popperContainer.addEventListener(event, e => this.fxHideTooltip(tooltip))
				} else {
					tooltip.addEventListener(event, e => this.fxHideTooltip(e.currentTarget))
				}
			})
		}
	}
}

tooltip.events()